import {config} from "./config";
import {request} from "./request";

function createOrUpdateConfig(data, cb, fail_cb) {
    request.post.call(this, config.apiList.taokeAccountConfigs, data, null, cb, fail_cb)
}

function getAccountConfigs(data, cb, fail_cb) {
    request.get.call(this, config.apiList.taokeAccountConfigs, data, cb, fail_cb)
}

function getAccountStatus(data, cb, fail_cb) {
    request.get.call(this, config.apiList.getAccountStatus, data, cb, fail_cb)
}


var accountConfigApi = {
    createOrUpdateConfig: createOrUpdateConfig,
    getAccountConfigs: getAccountConfigs,
    getAccountStatus:getAccountStatus
}

export {accountConfigApi}